export const CALC_FREE_DATA = 'CALC_FREE_DATA'
export const CALC_FREE_LIST = 'CALC_FREE_LIST'
export const CALC_GET_STATUS_LIST = 'CALC_GET_STATUS_LIST'
export const CALC_SET_FILTER = 'CALC_SET_FILTER' // Установка фильтра на список расчётов
export const CALC_GET_LIST = 'CALC_GET_LIST' // Получение списка расчётов, согласно установленному текущему фильтру
export const CALC_CREATE = 'CALC_CREATE' // Создание нового расчёта
export const CALC_UPDATE = 'CALC_UPDATE' // Изменение заголовка расчёта
export const CALC_DELETE = 'CALC_DELETE' // Удаление расчёта

export const CALC_GET = 'CALC_GET_RECEPTURE' // Получение расчёта по идентификатору
export const CALC_GET_ROUTE = 'CALC_GET_ROUTE' // Получение истории состояний расчёта

export const CALC_POST_STATE = 'CALC_POST_STATE' // Изменение статуса расчёта

export const CALC_ADD_FILE = 'CALC_ADD_FILE' // Добавление файла
export const CALC_DEL_FILE = 'CALC_DEL_FILE' // Удаление файла

export const CALC_SET_CURRENT = 'CALC_SET_CURRENT'
